var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.792,
    height: 16.443,
    viewBox: "0 0 18.792 16.443",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12439",
    "data-name": "Group 12439",
    transform: "translate(0 -3.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_16",
    "data-name": "Polygon 16",
    d: "M8.528,1.519a1,1,0,0,1,1.736,0l7.673,13.428a1,1,0,0,1-.868,1.5H1.723a1,1,0,0,1-.868-1.5Z",
    transform: "translate(0 3.222)",
    fill: "#07ff5c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrowGreen.3a51be8b5ab2cf08f2c28848fd799fe9.svg";
export { ForwardRef as ReactComponent };